const { classExists } = require("../helper/class-exists");

const detectScrollbarX = (elem) => {
	return elem.scrollWidth > elem.clientWidth;
};

const scrollbarButtons = (elem, tableScrollbar) => {
	const buttonContainer = elem.querySelector(".scrollbar-buttons");
	const buttons = buttonContainer.querySelectorAll("button");
	const scrollingPower = buttonContainer.dataset.scrollPower;

	for (let b = 0; b < buttons.length; b++) {
		buttons[b].addEventListener("click", function (event) {
			if (this.classList.contains("next")) {
				tableScrollbar.scrollBy({
					top: 0,
					left: scrollingPower,
					behavior: "smooth",
				});
			} else {
				tableScrollbar.scrollBy({
					top: 0,
					left: -1 * scrollingPower,
					behavior: "smooth",
				});
			}
		});
	}
};

const tableComparison = () => {
	const elems = document.querySelectorAll(".js-table-comparison");
	classExists(elems);

	for (let i = 0; i < elems.length; i++) {
		const tableScrollbar = elems[i].querySelector(".table-comparison");
		if (detectScrollbarX(tableScrollbar)) {
			elems[i].classList.add("has-scrollbar");
		} else {
			elems[i].classList.remove("has-scrollbar");
		}

		scrollbarButtons(elems[i], tableScrollbar);
	}
};

document.addEventListener("DOMContentLoaded", function () {
	tableComparison();
});

window.addEventListener(
	"resize",
	(event) => {
		tableComparison();
	},
	true
);
